import { render, staticRenderFns } from "./YouHaveCanceledLessonNotification.vue?vue&type=template&id=24e1de45&"
import script from "./YouHaveCanceledLessonNotification.vue?vue&type=script&lang=js&"
export * from "./YouHaveCanceledLessonNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports